/** Base header nav heights (px). Source of truth — synced to CSS vars on app init. */
export const BASE_NAV_HEIGHT = {
  desktop: 155,
  mobile: 79,
  generic: 110,
} as const;

export type NavHeightKey = keyof typeof BASE_NAV_HEIGHT;

export const NAV_HEIGHT_CSS_VARS: Record<NavHeightKey, string> = {
  generic: "--get-nav-height",
  desktop: "--get-nav-height-desktop",
  mobile: "--get-nav-height-mobile",
};

export const TOP_BANNER_MOBILE_HEIGHT_CSS_VAR =
  "--get-top-banner-mobile-height";

export const TOP_BANNER_DESKTOP_HEIGHT_CSS_VAR =
  "--get-top-banner-desktop-height";

/** Fixed bottom nav clearance on mobile design v2 (px). */
export const BOTTOM_NAV_HEIGHT_MOBILE = 92;

export const BOTTOM_NAV_HEIGHT_CSS_VAR = "--get-bottom-nav-height";

export const STICKY_FOOTER_BANNER_HEIGHT_CSS_VAR =
  "--get-sticky-footer-banner-height";

export const RECENT_ORDERS_TAB_BANNER_HEIGHT_CSS_VAR =
  "--get-recent-orders-tab-banner-height";

/** Combined bottom inset: bottom nav + optional sticky footer Braze banner. */
export const MOBILE_BOTTOM_CLEARANCE_CSS = `calc(var(${BOTTOM_NAV_HEIGHT_CSS_VAR}) + var(${STICKY_FOOTER_BANNER_HEIGHT_CSS_VAR}, 0px))`;
